import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './AuthProvider';
import { NotificationCenterProvider } from '../shared/components/toast';
import { Provider } from 'react-redux';
import { store } from '../shared/infra/redux';

type BaseProvidersProps = {
  children: React.ReactNode;
};

function BaseProviders({ children }: BaseProvidersProps) {
  return (
    <Router>
      <Provider store={store}>
        <NotificationCenterProvider autoDismiss={true} position='BOTTOM_RIGHT'>
          <AuthProvider>{children}</AuthProvider>
        </NotificationCenterProvider>
      </Provider>
    </Router>
  );
}

export default BaseProviders;
